<template>
  <div class="container">
    <header v-if="!loadingFormData && !loadingRegistrationData">
      <h2 class="form-title">{{ getTitle }}</h2>
      <div class="alert alert-info alert-required-fields" role="alert">
        Tous les champs de ce formulaire avec
        <span class="text-danger">*</span> sont
        <span class="text-danger">obligatoires</span>.
      </div>
      <div class="form-group exercice-form" v-if="$appSettings.IsLiberal">
        <label
          for="exerciceLiberalOuIndividuel"
          class="col-sm-5 control-label"
          v-html="$appSettings.LiberalActivityLabel"
        >
        </label>
        <select
          id="exerciceLiberalOuIndividuel"
          v-model="exerciceLiberalOuIndividuel"
          v-if="showQuestionExercice"
          class="form-control exercice-select"
        >
          <option :value="true">Oui</option>
          <option :value="false">Non</option>
        </select>
      </div>
    </header>
    <main>
      <div v-if="exerciceLiberalOuIndividuel">
        <form-individual
          :formData="formData"
          :registrationData="this.registrationData"
          v-if="!loadingFormData && !loadingRegistrationData && !loadingError"
        ></form-individual>
        <admin-loader
          :loading="loadingFormData"
          v-else-if="!loadingError"
        ></admin-loader>
        <div v-else class="alert alert-danger">
          {{ $texts.formLoadingError }}
        </div>
      </div>
      <form-structure v-else></form-structure>
    </main>
    <footer-panel-vuetify
      :silentRefreshUrl="$appSettings.SilentRefreshUrl"
    ></footer-panel-vuetify>
  </div>
</template>

<script>
import AdminLoader from "@/Commons/AdminLoader.vue";
import Vue from "vue";
import { InscriptionFlowService } from "@/InscriptionFlow/services/InscriptionFlowService";
import FormIndividual from "../../components/FormIndividual.vue";
import FormStructure from "../../components/FormStructure.vue";
import { RegistrationService } from "@/InscriptionFlow/services/RegistrationService";
import { RegistrationSubMode } from "@/InscriptionFlow/models/enums/RegistrationSubMode";
import FooterPanelVuetify from "@/Commons/components/FooterPanelVuetify.vue";

export default Vue.extend({
  name: "inscription-flow-register",

  components: {
    AdminLoader,
    FormIndividual,
    FormStructure,
    FooterPanelVuetify,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    idFormType: {
      type: Number,
      required: true,
    },
    email: {
      type: String,
    },
    nationalId: {
      type: String,
    },
  },

  data() {
    return {
      formData: null,
      registrationData: null,
      loadingFormData: false,
      loadingRegistrationData: false,
      loadingError: null,
      exerciceLiberalOuIndividuel: true,
      showQuestionExercice: true,
    };
  },

  computed: {
    getTitle() {
      switch (this.registrationData.registrationSubMode) {
        case RegistrationSubMode.Update:
          return this.$texts.titleFormUpdateRegister;
        default:
          return this.$texts.titleFormRegister;
      }
    },
  },

  methods: {
    async getFormData(name, idFormType) {
      this.loadingFormData = true;
      InscriptionFlowService.getFormData(name, idFormType)
        .then((formData) => {
          this.formData = formData;
          this.loadingFormData = false;
        })
        .catch((error) => {
          this.loadingError = error;
        })
        .finally(() => (this.loadingFormData = false));
    },
    async getRegistrationData(name) {
      this.loadingRegistrationData = true;
      RegistrationService.initialization(name)
        .then((registrationData) => {
          this.registrationData = registrationData;
          this.loadingRegistrationData = false;
          if (this.email != null) {
            this.registrationData.user.email = this.email;
          }
          if (this.nationalId != null) {
            this.registrationData.user.nationalId = this.nationalId;
          }
        })
        .catch((error) => {
          this.loadingError = error;
        })
        .finally(() => (this.loadingFormData = false));
    },
  },

  watch: {
    name: {
      immediate: true,
      handler(val) {
        this.getFormData(val, this.idFormType);
        this.getRegistrationData(val, this.idFormType);
      },
    },
  },
});
</script>

<style scoped>
header {
  text-align: left;
  border-bottom: 1px solid grey;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

main {
  text-align: left;
}

.exercice-form {
  display: flex;
  justify-content: space-between;
}

.exercice-select {
  width: auto;
  min-width: 150px;
}

.control-label {
  margin-top: 7px;
}
</style>
